import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Opiniontype } from './opiniontype';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OpiniontypeService {
  baseUrl: string = environment.serviceUrl;

  constructor(private httpClient: HttpClient) {
  }

  Get(): Observable<Opiniontype[]> {
    return this.httpClient.get<Opiniontype[]>(this.baseUrl + 'api/OpiniontypeApi')
  }
  Post(opiniontype: Opiniontype): Observable<any> {

    let header = new HttpHeaders();
    header = header.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post(this.baseUrl + 'api/OpiniontypeApi/add', opiniontype, { headers: header, observe: 'response' })
  }
  Delete(opiniontype: Opiniontype) {
    let header = new HttpHeaders();
    header = header.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post(this.baseUrl + 'api/OpiniontypeApi/activeordeactive', opiniontype, { headers: header, observe: 'response' })
  }
  Put(opiniontype: Opiniontype): Observable<any> {
    let header = new HttpHeaders();
    header = header.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.put(this.baseUrl + 'api/OpiniontypeApi/Update', opiniontype, { headers: header, observe: 'response' })
  }


}
